<!-- Submenu section -->
<ul
  class="mt-submenu-sidebar-link-wrapper mt-white sidebar-submenu submenu-wrapper list-unstyled bg-white shadow-sm position-absolute"
>
  <ng-container *ngFor="let menu of menus">
    <ng-container [ngSwitch]="menu.name">
      <div *ngSwitchCase="'SIGNATURES'" mt-claim-authorization [requiredClaim]="'Signature:View'">
        <li class="nav-item">
          <a [routerLink]="menu.url" routerLinkActive="active" class="show">
            <ng-container [ngTemplateOutlet]="renderSideMenuData" [ngTemplateOutletContext]="{ menu }"></ng-container>
          </a>
        </li>
      </div>

      <div
        *ngSwitchCase="'Default_Signatures'"
        mt-claim-authorization
        [requiredClaim]="'DefaultSignatures:View'"
      >
        <li class="nav-item">
          <a [routerLink]="menu.url" routerLinkActive="active" class="show">
            <ng-container [ngTemplateOutlet]="renderSideMenuData" [ngTemplateOutletContext]="{ menu }"></ng-container>
          </a>
        </li>
      </div>
    </ng-container>
  </ng-container>

  <!-- Displays sidemenu data -->
  <ng-template let-menu="menu" #renderSideMenuData>
    <div class="mt-submenu-icon">
      <mt-svg class="h12 mt-submenu-icon mt-brand-100" src="{{ menu.image }}"> </mt-svg>
    </div>
    <span class="mt-submenu-title inline-block" [transloco]="menu.name"></span>
    <span *ngIf="menu.hasCounter" class="mt-submenu-counter">
      {{ signatureCount }}
    </span>
  </ng-template>
</ul>
